import { render, staticRenderFns } from "./IssuesPage.vue?vue&type=template&id=19774e01&"
import script from "./IssuesPage.vue?vue&type=script&lang=js&"
export * from "./IssuesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports